<!-- OCENE -->
<div class="ion-padding about-saloon" style="padding-top:0px;">
  <h3 class="about-saloon__title">{{ 'SHOP_DETAIL.RATINGS.TITLE' | translate }}</h3>

  <div class="about-saloon__desc expanded" > 
    <p>{{ 'SHOP_DETAIL.RATINGS.TEXT' | translate }}</p>
  </div>
  <br>
  <img class="hidden-sm-down" [src]="'../../../assets/images/ratings-desktop_' + translateService.currentLang + '.png'">
  <img class="hidden-md-up" [src]="'../../../assets/images/ratings-mobile_' + translateService.currentLang + '.png'">
</div>
